import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getApiV2ProductsId,
  getProductPath,
  type GetProductParams,
} from '@hungryroot/rest/api/v2/products/[id]/get';

type OptionType = Pick<UseQueryOptions, 'enabled'>;

export function useProduct(
  queryParams: GetProductParams,
  options?: OptionType
) {
  return useQuery({
    queryKey: [getProductPath(queryParams)],
    queryFn: async () => {
      const resp = await getApiV2ProductsId(queryParams);

      if (resp.status !== StatusCode.SuccessOK) {
        throw resp.data;
      }

      return resp.data;
    },
    ...options,
    gcTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    retry: 0,
  });
}
